import { render, staticRenderFns } from "./SurveyManagementBasicQuestion.vue?vue&type=template&id=0e546290&scoped=true&"
import script from "./SurveyManagementBasicQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementBasicQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementBasicQuestion.vue?vue&type=style&index=0&id=0e546290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e546290",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementBasicQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e546290')) {
      api.createRecord('0e546290', component.options)
    } else {
      api.reload('0e546290', component.options)
    }
    module.hot.accept("./SurveyManagementBasicQuestion.vue?vue&type=template&id=0e546290&scoped=true&", function () {
      api.rerender('0e546290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/SurveyManagementBasicQuestion.vue"
export default component.exports